'use client';

import useForkRef from '@mui/utils/useForkRef';
export default useForkRef;